import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchHotkeyGroupDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'hotkey_group/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchHotkeyGroupItems(app, data) {
  const { itemId } = data;
  const service = common.getAccountService(app, DocType.HOTKEY_GROUP_ITEM);
  return service.find({
    query: {
      selector: {
        doc_type: DocType.HOTKEY_GROUP_ITEM,
        'item._id': itemId
      },
    }
  }).then(res => {
    return res.docs;
  });
}

export function fetchHotKeyGroupById(app, params) {
  const { id } = params;
  const docType = 'hotkey_group';
  return common.getDoc(app, { id, docType });
}

export function fetchHotkeyGroups(app, data) {
  console.log('fetchHotkeyGroups', data);
  const { hotkeyGroupIds } = data;
  const service = common.getAccountService(app, DocType.HOTKEY_GROUP_ITEM);
  return service.find({
    query: {
      selector: {
        _id: {
          $in: hotkeyGroupIds
        }
      },
    }
  }).then(util.getMangoQueryDocs);
}

export function saveHotkeyGroup(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  
  let hotkeyGroupData = {
    doc_type: DocType.HOTKEY_GROUP,
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    image_thumb: util.toStringText(data.image_thumb),
    image_url: util.toStringText(data.image_url),
    is_class: util.toBoolean(data.is_class),
    active: true,
    parent_id: data.parent_id ? data.parent_id : null,
    classification_id: data.classification_id ? data.classification_id : null,
    hotkey_group_items: util.toObjectIds(
      data.hotkey_group_items,
      data.hotkey_group_item_ids,
      'hotkey_group_item_id',
    ),
  };

  return common.saveDoc(app, {
    source: data,
    doc: hotkeyGroupData,
    user
  });
}

export function deleteHotkeyGroup(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.HOTKEY_GROUP
  });
}

export function deleteHotkeyGroupItemsByHotkeyGroupId(app, data) {
  const { id } = data;
  const service = common.getAccountService(app, DocType.HOTKEY_GROUP_ITEM);
  if (id) {
    const params = {
      query: {
        selector: {
          doc_type: DocType.HOTKEY_GROUP_ITEM,
          'hotkey_group._id': id
        },
      }
    };
    return service.find(params)
      .then(res => {
        return res.docs.map((doc) => {
          console.log("Removing hotkey_group_item", doc);
          return common.deleteDoc(app, { id: doc.id, docType: DocType.HOTKEY_GROUP_ITEM });
        });
      })
      .catch(common.handleError)
  }
}

export function deleteHotkeyGroupItem(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.HOTKEY_GROUP_ITEM
  });
}
